import { preferStableObjectReferenceArray } from "./preferStableObjectReferenceArray";
/**
 * Keep a stable references to objects in an array.
 * @param previous
 * @param current
 * @returns A new array with
 */
export function preferStableObjectReferenceArrayNullable(previous, current) {
    if (previous == null) {
        return current;
    }
    if (current == null) {
        return current;
    }
    return preferStableObjectReferenceArray(previous, current);
}
//# sourceMappingURL=preferStableObjectReferenceArrayNullable.js.map